<!-- <div style="text-align:center">
        <textarea name="ctl00$ContentPlaceHolder1$txtMessage" rows="2" cols="20" readonly="readonly" id="ctl00_ContentPlaceHolder1_txtMessage" style="font-family:verdana;font-size:Small;height:146px;width:695px;">This is an error page for Hydrostatic test.  No error message was received!</textarea>
    </div> -->


    <div class="error-page-container" >
        <div>
            <h1>Oops!</h1>
            <p >
                This is an error page for Hydrostatic test.<br>
                <strong>No error message was received!</strong>
            </p>
            <button  onclick="window.location.href='/'">
                Go to Home
            </button>
        </div>
    </div>